import http from "@/http/http"
import { DDT_API } from "@/constants/config"

const token =
  "Ywea7LXyXu13vkuUKtf94tVlxagBvmIuiIWrZ_H1eTNGi3xgU0YpgiZe8r0BCQpNPknwaMJMc9ugFICL1PHvpmFyuJxH3x0kCvfbu5i4afY9KaYN225P3KCb3VyFqD6ZzPYmpqSR2adLy9739iD1-EnmivpiGmvNCA9ZNGVLX873DNvXZVeOF80epAX_XEBRkvcH5nzks9q3_apzgXUETzQuUW3E8moA-zJxihm2qyt5y3X1brwjNGKBJw2KLvGJZwerbjAf1Q8MAkVVRhbe1Q"

// 街道画像
export const getStreetProfile = async (code: number) => {
  try {
    const result = await http.get(`${DDT_API}/v1/street/profile`, {
      params: {
        keyword: code,
      },
      headers: {
        authorization: token,
        token,
      },
    })

    return result
  } catch (error) {
    throw error
  }
}

interface StreetOverviewArgs {
  keyword: number
  code: number
}

// 区县polygon
export const getStreetOverview = async (args: StreetOverviewArgs) => {
  try {
    const result = await http.get(`${DDT_API}/v1/street/overview`, {
      params: args,
      headers: {
        authorization: token,
        token,
      },
    })

    return result
  } catch (error) {
    throw error
  }
}
